import {
  NetworkIdSchema
} from "./chunk-JUEBKEUX.mjs";

// src/cards/justShippedCard.ts
import z from "zod";
var JustShippedCardSchema = z.object({
  title: z.string(),
  description: z.string(),
  url: z.string().url(),
  // URLs are already being validated by the Statsig dynamic config (https://tinyurl.com/24mnlc4u)
  ctaLabel: z.string().optional(),
  networkId: NetworkIdSchema.optional()
  // Only show the card if the user has access to the network
});

export {
  JustShippedCardSchema
};
//# sourceMappingURL=chunk-ZLNUORAA.mjs.map